import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ModalConfirmV2, ModalSizeVariants } from '@labrav/react-components'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { Typography } from '@mui/material'
import { useStyles } from './DeleteConfirmationModal.styles'
import { getIntegrationTypeLabel } from '../../../helpers'

interface DeleteConfirmationModalProps {
  handleDeleteModal: () => void
  open: boolean
  onClose: () => void
  selectedIntegrationType: string | null
}

export const DeleteConfirmationModal: React.FC<
  DeleteConfirmationModalProps
> = ({ handleDeleteModal, open, onClose, selectedIntegrationType }) => {
  const { classes } = useStyles()
  const typeLabel = getIntegrationTypeLabel(selectedIntegrationType)
  return (
    <ModalConfirmV2
      title={`Delete ${typeLabel}?`}
      content={
        <Typography className={classes.lightText}>
          Are you sure you want to delete this {typeLabel}?
        </Typography>
      }
      open={open}
      titleAcceptButton="Delete"
      onAccept={handleDeleteModal}
      onDecline={onClose}
      variant={ModalSizeVariants.small}
      icon={
        <FontAwesomeIcon
          icon={faTrash}
          style={{ width: '20px', height: '16px' }}
        />
      }
      hideCancelIcon={false}
      hideCancelButton={false}
    />
  )
}
